import "./App.css"
import Canvas from "./Components/Canvas"

function App() {
  return (
    <div className="App">
      <Canvas width={400} height={300} />
    </div>
  )
}

export default App
